export default __webpack_public_path__ + "static/media/Add.44082ed4.svg";